import { StyledComponent } from '@emotion/styled';
import { Chip, ChipProps, Theme } from '@mui/material';
import { MUIStyledCommonProps, styled } from '@mui/system';
import type { StyledChipPropTypes } from './Chip.types';

function getHeight({ size, theme }: StyledChipPropTypes) {
  if (size === 'large') return theme.spacing(14);
  if (size === 'medium') return theme.spacing(7.5);
  if (size === 'small') return theme.spacing(6);
  return theme.spacing(7.5);
}

function getPadding({ size, theme }: StyledChipPropTypes) {
  if (size === 'large') return theme.spacing(4, 4);
  if (size === 'medium') return theme.spacing(1, 3);
  if (size === 'small') return theme.spacing(1, 2);
  return theme.spacing(1, 3);
}
function getFontSize({ size, theme }) {
  if (size === 'small') {
    return theme.spacing(3);
  }
  return theme.spacing(3.5);
}
export const StyledChip: StyledComponent<
  ChipProps,
  MUIStyledCommonProps<Theme>,
  any
> = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'textColor',
})`
  color: ${({ textColor, theme }: StyledChipPropTypes) =>
    theme.palette?.[textColor]?.main || null};
  border-radius: ${({ theme }: { theme: Theme }) => theme.spacing(4)};
  height: ${getHeight};
  min-height: ${getHeight};
  max-height: ${getHeight};
  line-height: ${({ theme }: StyledChipPropTypes) => theme.spacing(4)};
  padding: ${getPadding};
  font-size: ${getFontSize};
  min-width: ${({ fullWidth }: StyledChipPropTypes) =>
    fullWidth ? '100%' : 'unset'};
  gap: ${({ theme }: StyledChipPropTypes) => theme.spacing(3)};
  .MuiChip-label {
    padding: 0;
  }
  .MuiChip-deleteIconMedium {
    margin-right: 0;
    width: fit-content;
  }
  .MuiChip-label {
    flex-grow: 1;
  }
  ${({ theme }) => theme.breakpoints.up('sm')} {
    font-size: ${({ theme }: StyledChipPropTypes) => theme.spacing(3.5)};
  }
`;
